import { BoxLockModalEventData } from '../../types'

export function loadBoxModal(boxModalVersion = '3.6.0', windowProp: Window | undefined = window) {
  const _window = windowProp || window
  if (!_window.showBoxLockModal) {
    const queue: BoxLockModalEventData[] = []
    _window.showBoxLockModal = Object.assign(
      (eventData: BoxLockModalEventData) => {
        _window.showBoxLockModal?.queue.push(eventData)
      },
      { queue }
    )
    const script = _window.document.createElement('script')
    script.async = true
    script.src = `https://static.jusbr.com/box-modal/${boxModalVersion}/bundle.min.js`
    _window.document.body.appendChild(script)
  }
}
